<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      
      <div>
        
        <div class="flex items-center gap-1">


          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Equipo que vende dentro de una compañía. Agrupa personas/departamentos
                con metas y métricas propias; define a qué clientes atiende cada equipo.
                Úsalo para separar equipos por región, tipo de cliente o línea de producto
                y medir resultados claros.</p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Organización de Ventas
          </h2>
        </div>
       <!-- <h2 class="text-xl font-semibold leading-8 tracking-tight">
          Organización de Ventas
        </h2>-->
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina las <b>organizaciones de venta</b> que operan dentro de AVE para una <b>compañia</b>.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Organizaciones de Ventas</div> -->
           <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]"
            [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- <button mat-stroked-button color="primary" (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span>Exportar</span>
          </button> -->
          <!-- Add button (only icon) -->
          <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              [trackBy]="trackByFn">
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                <td mat-cell *matCellDef="let sales" class="text-sm uppercase leading-tight">
                  <div *ngIf="getCode(sales) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  {{ sales.name }}
                </td>
              </ng-container>
  
              <!-- Estado -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let sales">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="sales.statusId == 1"
                    [(ngModel)]="sales.statusId" [color]="'success'" (ngModelChange)="onStatusChange($event, sales)">
                  </mat-slide-toggle>
                </td>
              </ng-container>
  
              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let sales" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(sales)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(sales)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
  
              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
  
              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
          </div>
        </div>
  
        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>
  
      <!-- Modales -->
      <ng-template #addModal>
        <h2 mat-dialog-title class="text-xl font-bold mb-4 border-b">Nuevo Registro</h2>
        <mat-dialog-content class="overflow-y-auto max-h-full">
          <form #createForm="ngForm" class="space-y-8 flex flex-col">
            <app-form-section title="Información Básica" icon="business" iconColor="blue">
              <div class="space-y-4">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Nombre</mat-label>
                  <input matInput [(ngModel)]="currentCreateSalesOrganization.name" name="name" required>
                  <mat-error *ngIf="!currentCreateSalesOrganization.name">Este campo es requerido</mat-error>
                </mat-form-field>
                
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">Compañía *</label>
                  <ng-select
                    [(ngModel)]="currentCreateSalesOrganization.companyId"
                    [items]="companyList"
                    bindLabel="name"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Seleccione una compañía"
                    name="companyId"
                    [appendTo]="'body'"
                    required
                  >
                  </ng-select>
                </div>
              </div>
            </app-form-section>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end px-6 py-4 border-t">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button 
            mat-raised-button color="primary" 
            (click)="createSalesOrganization()"  
            [disabled]="!createForm.valid">Guardar</button>
        </mat-dialog-actions>
      </ng-template>
  
      <!-- Modal Editar -->
      <ng-template #editModal>
        <h2 mat-dialog-title class="text-xl font-bold mb-4 border-b">Editar Registro</h2>
        <mat-dialog-content class="overflow-y-auto max-h-full">
          <form #editForm="ngForm" class="space-y-8 flex flex-col">
            <app-form-section title="Información Básica" icon="business" iconColor="blue">
              <div class="space-y-4">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Nombre</mat-label>
                  <input matInput [(ngModel)]="currentUpdateSalesOrganization.name" name="name" required>
                  <mat-error *ngIf="!currentUpdateSalesOrganization.name">Este campo es requerido</mat-error>
                </mat-form-field>
                
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">Compañía *</label>
                  <ng-select
                    [(ngModel)]="currentUpdateSalesOrganization.company"
                    [items]="companyList"
                    bindLabel="name"
                    bindValue="_id"
                    [searchable]="true"
                    placeholder="Seleccione una compañía"
                    name="companyId"
                    [compareWith]="compareById"
                    (ngModelChange)="onCompanySelectionChange($event)"
                    [appendTo]="'body'"
                    required
                  >
                  </ng-select>
                </div>
              </div>
            </app-form-section>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end px-6 py-4 border-t">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
          <button 
            mat-raised-button color="primary" 
            (click)="updateSalesOrganization(currentUpdateSalesOrganization._id)"
            [disabled]="!editForm.valid">Guardar</button>
        </mat-dialog-actions>
      </ng-template>
  
      <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
          <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
              style="font-size: 32px;"></mat-icon>
          </div>
          <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
            <mat-dialog-content class="modal-content mt-0">
              <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
          </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Conservar</button>
          <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
        </mat-dialog-actions>
      </ng-template>
  </div>

  <app-filter
    (onFilterEvent)="findAllWithCount()"
    (onCleanEvent)="onClearFilter()"
    (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters
      [form]="form"
      [company]="true"
      [loadData]="loadFiltersData">
    </app-configuration-filters>
  </app-filter>
  
</mat-sidenav-container>
  